import React from 'react';
const TikTokPage: React.FC = () => (
  <div style={{ padding: 32 }}>
    <div style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 6 }}>🎵 TikTok</div>
    <div style={{ color: '#C8C8E8', fontSize: 14, marginBottom: 28 }}>Publication TikTok — en attente validation developers.tiktok.com</div>
    <div style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 20, padding: 32, textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>🎵</div>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#F8F7FF', marginBottom: 8 }}>TikTok — Bientôt disponible</div>
      <div style={{ fontSize: 13, color: '#C8C8E8' }}>L'app est en attente de validation sur developers.tiktok.com. En attendant, utilise le Studio pour créer tes vidéos et publie-les manuellement.</div>
    </div>
  </div>
);
export default TikTokPage;
